import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdminEmail } from '../lib/admins';

/**
 * Garde de route admin : redirige AVANT le rendu si l'utilisateur n'est pas
 * administrateur (plus de flash de l'UI admin). Défense en profondeur : la page
 * conserve aussi son propre contrôle, et les données sont protégées par les
 * règles Firestore.
 */
export function AdminRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen bg-[#0d0e12] flex items-center justify-center text-white">Chargement...</div>;
  }
  if (!user) {
    return <Navigate to="/" replace />;
  }
  if (!isAdminEmail(user.email)) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
}
